import React, { createContext, useContext, useState } from 'react';

export interface Product {
  id: string;
  landing_page_link?: string;
  product: string;
  description?: string;
  type: "Product" | "Service" | "Hook";
  funnel_stage: "TofU" | "MofU" | "BofU" | "Conversion";
  category_id?: string;
  subcategory_id?: string;
  tags: string[];
  more_tags: string[];
  tag3: string[];
  price?: number;
  price_range_from?: number;
  price_range_to?: number;
  status: 'active' | 'inactive' | 'discontinued';
  third_party_product_id?: string;
  images?: string[];
  created_at: string;
  updated_at: string;
}

interface ProductContextType {
  isOpen: boolean;
  editingProduct: Product | null;
  openAddProduct: () => void;
  openEditProduct: (product: Product) => void;
  closeProductDialog: () => void;
}

const ProductContext = createContext<ProductContextType | undefined>(undefined);

export const ProductProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState<Product | null>(null);

  const openAddProduct = () => {
    setEditingProduct(null);
    setIsOpen(true);
  };

  const openEditProduct = (product: Product) => {
    setEditingProduct(product);
    setIsOpen(true);
  };

  const closeProductDialog = () => {
    setIsOpen(false);
    setEditingProduct(null);
  };

  return (
    <ProductContext.Provider 
      value={{ 
        isOpen, 
        editingProduct, 
        openAddProduct, 
        openEditProduct, 
        closeProductDialog 
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export const useProduct = () => {
  const context = useContext(ProductContext);
  if (context === undefined) {
    throw new Error('useProduct must be used within a ProductProvider');
  }
  return context;
};
